import { BriefcaseIcon, BuildingOfficeIcon } from '@heroicons/react/24/outline'
import React from 'react'

interface IconResultProps {
  type: 'offer' | 'firm'
}

export const IconResult = ({ type }: IconResultProps) => {
  const className = "size-6 flex-none text-gray-500 group-data-focus:text-white forced-colors:group-data-focus:text-[Highlight]"

  if (type === 'offer') {
    return <BriefcaseIcon className={className} aria-hidden="true" data-testid="briefcase-icon" />
  }

  return <BuildingOfficeIcon className={className} aria-hidden="true" data-testid="building-office-icon" />
}
